import React, { useState } from 'react';
import { GitBranch, BarChart3, Gift } from 'lucide-react';
import { useTheme } from '../../../context/ThemeContext';
import { useAuth } from '../../../context/AuthContext';
import TeamOrgPanel from '../../management/TeamOrgPanel';
import UsagePanel from '../../management/usage/UsagePanel';
import CompClientsPanel from '../../management/comp/CompClientsPanel';

export default function ManagementDashboard() {
  const { theme } = useTheme();
  const { canAccess } = useAuth();
  const [panel, setPanel] = useState('usage');

  const canComp = canAccess && canAccess('service_comp_admin');
  const panels = [
    { key: 'usage', label: 'Usage', icon: BarChart3 },
    { key: 'team', label: 'Team / Org', icon: GitBranch },
    ...(canComp ? [{ key: 'comp', label: 'Comp Clients', icon: Gift }] : []),
  ];

  return (
    <div className={`flex flex-col h-full ${theme === 'dark' ? 'bg-gray-900 text-white' : 'bg-gray-50 text-gray-900'}`}>
      {/* Header */}
      <div className={`flex items-center justify-between px-6 py-4 border-b ${theme === 'dark' ? 'border-gray-700' : 'border-gray-200'}`}>
        <div className="flex items-center gap-3">
          <GitBranch size={24} />
          <h1 className="text-xl font-dm-serif font-semibold">Management</h1>
        </div>
      </div>

      {/* Top-level panels */}
      <div className={`flex gap-1 px-6 pt-3 border-b ${theme === 'dark' ? 'border-gray-700' : 'border-gray-200'}`}>
        {panels.map(p => {
          const Icon = p.icon;
          return (
            <button
              key={p.key}
              onClick={() => setPanel(p.key)}
              className={`flex items-center gap-2 px-4 py-2 text-sm font-rasa font-medium rounded-t-lg transition-colors ${
                panel === p.key
                  ? `${theme === 'dark' ? 'bg-gray-800 text-white' : 'bg-white text-blue-600'} border-b-2 border-blue-600`
                  : `${theme === 'dark' ? 'text-gray-400 hover:text-gray-300' : 'text-gray-500 hover:text-gray-700'}`
              }`}
            >
              <Icon size={16} />
              {p.label}
            </button>
          );
        })}
      </div>

      {/* Content */}
      <div className="flex-1 overflow-auto p-6">
        {panel === 'team' && <TeamOrgPanel />}
        {panel === 'comp' && canComp && <CompClientsPanel />}
        {panel === 'usage' && <UsagePanel />}
      </div>
    </div>
  );
}
